module.exports = __webpack_public_path__ + "img/Personalmanagement.178fc108.svg";